var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0835 11.9269H10.9168V13.7603H9.0835V11.9269ZM9.0835 4.59359H10.9168V10.0936H9.0835V4.59359ZM9.991 0.0102539C4.931 0.0102539 0.833496 4.11692 0.833496 9.17692C0.833496 14.2369 4.931 18.3436 9.991 18.3436C15.0602 18.3436 19.1668 14.2369 19.1668 9.17692C19.1668 4.11692 15.0602 0.0102539 9.991 0.0102539ZM10.0002 16.5103C5.9485 16.5103 2.66683 13.2286 2.66683 9.17692C2.66683 5.12525 5.9485 1.84359 10.0002 1.84359C14.0518 1.84359 17.3335 5.12525 17.3335 9.17692C17.3335 13.2286 14.0518 16.5103 10.0002 16.5103Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f04944b3.svg";
export { ForwardRef as ReactComponent };